var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.76 136.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 0 67.44 0 67.44 22.37 26.88 22.37 26.88 33.24 61.7 33.24 61.7 54.01 26.88 54.01 26.88 87.24 0 87.24 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "76.97 0 149.18 0 149.18 22.37 103.85 22.37 103.85 33.24 145.02 33.24 145.02 54.01 103.85 54.01 103.85 64.88 150.53 64.88 150.53 87.24 76.97 87.24 76.97 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163,0h44.1c29.08,0,39.35,21.5,39.35,43.49,0,26.77-14.16,43.75-44.6,43.75H163V0Zm26.88,64.88h10.51c16.75,0,19.18-13.57,19.18-21.76,0-5.5-1.72-20.77-21.15-20.77h-8.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.22,0h26.27l31.78,87.24H312.41l-3.67-12.46H281L277.1,87.24h-27Zm21.13,56.08L295.53,29.2h-.24l-8.42,26.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 98.08 11.03 98.08 11.03 100.04 2.8 100.04 2.8 103.42 10.04 103.42 10.04 105.27 2.8 105.27 2.8 111.01 0 111.01 0 98.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "13.29 98.08 24.8 98.08 24.8 100.04 16.09 100.04 16.09 103.42 24.14 103.42 24.14 105.27 16.09 105.27 16.09 109.06 24.95 109.06 24.95 111.01 13.29 111.01 13.29 98.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.41,98.08H34c4.92,0,7.05,2.9,7.05,6.48S39,111,34,111H27.41Zm2.8,11.1H33c4.38,0,5.32-2,5.32-4.62s-.94-4.63-5.32-4.63H30.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.58 98.08 55.08 98.08 55.08 100.04 46.37 100.04 46.37 103.42 54.44 103.42 54.44 105.27 46.37 105.27 46.37 109.06 55.24 109.06 55.24 111.01 43.58 111.01 43.58 98.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.69,98.08h7.63c3.49,0,5.28,1.32,5.28,3.51A3.31,3.31,0,0,1,68,104.85v0a2.52,2.52,0,0,1,2.37,2.75c0,1.5.27,2.87.88,3.4h-3a3,3,0,0,1-.44-1.91c0-2.37-.59-3.43-3.17-3.43H60.49V111h-2.8V98.08Zm2.8,5.89h4.6c1.77,0,2.72-.71,2.72-2.07,0-1.65-1.32-2-2.77-2H60.49v4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.75,98.08h3l6.16,13h-3l-1.51-3.43H76L74.49,111H71.6Zm-1,7.79h4.88l-2.39-5.56h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.2,102.2c-.48-1.49-1.65-2.58-4-2.58a4.58,4.58,0,0,0-4.86,4.92c0,2.48,1.43,4.94,4.86,4.94a3.76,3.76,0,0,0,4.07-3.39H102c-.22,3.1-2.94,5.23-6.8,5.23-4.79,0-7.66-3.08-7.66-6.76s2.86-6.79,7.66-6.79c3.61,0,6.44,1.63,6.79,4.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 104.58,
    y: 98.08,
    width: 2.8,
    height: 12.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.28,104.56c0,3.69-2.86,6.76-7.65,6.76s-7.66-3.08-7.66-6.76,2.86-6.79,7.66-6.79,7.65,3.09,7.65,6.79m-12.51,0a4.86,4.86,0,1,0,9.72,0c0-2.5-1.43-4.93-4.86-4.93s-4.86,2.43-4.86,4.93M118,94.48h3l-3.18,2.59H116Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "127.74 98.08 130.69 98.08 137.99 107.61 138.03 107.61 138.03 98.08 140.7 98.08 140.7 111.01 137.75 111.01 130.47 101.5 130.4 101.5 130.4 111.01 127.74 111.01 127.74 98.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "150.26 98.08 161.77 98.08 161.77 100.04 153.04 100.04 153.04 103.42 161.11 103.42 161.11 105.27 153.04 105.27 153.04 109.06 161.92 109.06 161.92 111.01 150.26 111.01 150.26 98.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.16,102.2c-.48-1.49-1.66-2.58-4-2.58a4.58,4.58,0,0,0-4.86,4.92c0,2.48,1.43,4.94,4.86,4.94a3.78,3.78,0,0,0,4.07-3.39H178c-.23,3.1-2.94,5.23-6.8,5.23-4.79,0-7.67-3.08-7.67-6.76s2.87-6.79,7.67-6.79c3.59,0,6.44,1.63,6.78,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.36,98.08h2.81v7.53c0,1.75.13,3.76,3.75,3.76s3.76-2,3.76-3.76V98.08h2.8v8.28c0,3.31-2.62,5-6.56,5s-6.56-1.65-6.56-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201,98.08h3l6.16,13h-3l-1.5-3.43h-6.39l-1.5,3.43h-2.89Zm-1,7.79h4.88l-2.4-5.56h-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "208.08 98.08 221.02 98.08 221.02 100.04 215.94 100.04 215.94 111.01 213.14 111.01 213.14 100.04 208.08 100.04 208.08 98.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.35,104.56c0,3.69-2.86,6.78-7.65,6.78s-7.66-3.09-7.66-6.78,2.86-6.79,7.66-6.79,7.65,3.09,7.65,6.79m-12.51,0a4.6,4.6,0,0,0,4.86,4.93c3.43,0,4.86-2.44,4.86-4.93a4.59,4.59,0,0,0-4.86-4.93c-3.43,0-4.86,2.43-4.86,4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.92,98.08h7.63c3.49,0,5.28,1.32,5.28,3.51a3.31,3.31,0,0,1-2.64,3.26v0a2.52,2.52,0,0,1,2.37,2.75c0,1.5.27,2.87.88,3.4h-3a3,3,0,0,1-.43-1.91c0-2.37-.6-3.43-3.18-3.43h-4.11V111h-2.8V98.08Zm2.8,5.89h4.59c1.76,0,2.73-.71,2.73-2.07,0-1.65-1.33-2-2.77-2h-4.55v4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 255.69,
    y: 98.08,
    width: 2.8,
    height: 12.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.2,98.08h3l6.15,13h-3l-1.51-3.43h-6.38L263,111h-2.89Zm-1,7.79h4.88l-2.39-5.56h-.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.76 98.08 279.71 98.08 287 107.61 287.05 107.61 287.05 98.08 289.72 98.08 289.72 111.01 286.77 111.01 279.49 101.5 279.42 101.5 279.42 111.01 276.76 111.01 276.76 98.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.32,98.08h3l6.16,13h-3L302,107.6h-6.38L294.07,111h-2.89Zm-1,7.79h4.87l-2.38-5.56h-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.22,98.08h6.63c4.92,0,7,2.9,7,6.48s-2.11,6.47-7,6.47h-6.63Zm2.8,11.1h2.76c4.38,0,5.32-2,5.32-4.62s-.94-4.63-5.32-4.63H317Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "330.39 98.08 341.91 98.08 341.91 100.04 333.2 100.04 333.2 103.42 341.25 103.42 341.25 105.27 333.2 105.27 333.2 109.06 342.06 109.06 342.06 111.01 330.39 111.01 330.39 98.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.08,119.27h5.71l8.08,16.46H16l-1.33-2.95H7.14l-1.35,2.95H0Zm.36,10.34h4.91L11,123.85H10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.47,135.73H39.84l-.33-1.79c-1.49,1.6-4,2.15-6,2.15-6.53,0-10.77-3.8-10.77-8.57s4.24-8.58,10.77-8.58c4.47,0,9.26,1.82,9.77,6H37.64c-.18-1.4-2-2.25-4.27-2.25-3.62,0-5,2.45-5,4.89s1.4,4.89,5,4.89c2.79,0,4.65-1,5-2.49H34.4v-3.17h9.08v9Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "47.07 119.27 64.3 119.27 64.3 122.72 52.71 122.72 52.71 125.59 63.3 125.59 63.3 128.9 52.71 128.9 52.71 132.05 64.59 132.05 64.59 135.73 47.07 135.73 47.07 119.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "67.75 119.27 73.54 119.27 81.04 129.41 81.1 129.41 81.1 119.27 86.39 119.27 86.39 135.73 80.61 135.73 73.11 125.47 73.05 125.47 73.05 135.73 67.75 135.73 67.75 119.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "107.37 122.97 100.93 122.97 100.93 135.73 95.31 135.73 95.31 122.97 88.87 122.97 88.87 119.27 107.37 119.27 107.37 122.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "109.88 119.27 127.08 119.27 127.08 122.72 115.5 122.72 115.5 125.59 126.09 125.59 126.09 128.9 115.5 128.9 115.5 132.05 127.4 132.05 127.4 135.73 109.88 135.73 109.88 119.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135,130.2c.12,1.94,1.7,2.57,4.09,2.57,1.7,0,3.44-.47,3.44-1.69,0-1.44-3.08-1.73-6.2-2.4S130,127,130,123.94c0-3.59,4.74-5,8.8-5,4.29,0,8.61,1.6,8.64,5.31h-5.62c.09-1.5-1.76-2-3.47-2-1.21,0-2.73.33-2.73,1.4,0,1.27,3.12,1.51,6.26,2.16s6.26,1.78,6.26,4.74c0,4.18-4.65,5.51-9.4,5.51-5,0-9.35-1.66-9.38-5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.35,119.27h9.29c6.62,0,10.59,3.07,10.59,8.16,0,5.4-4,8.3-10.59,8.3h-9.29ZM166,132.05h2.67c4.27-.07,6-1.34,6-4.64,0-3-2.12-4.44-6-4.44H166Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "183.33 119.27 200.54 119.27 200.54 122.72 188.95 122.72 188.95 125.59 199.54 125.59 199.54 128.9 188.95 128.9 188.95 132.05 200.85 132.05 200.85 135.73 183.33 135.73 183.33 119.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.47,119.27h5.71l8.09,16.46h-5.86l-1.33-2.95h-7.53l-1.36,2.95h-5.77Zm.36,10.34h4.91l-2.39-5.76h-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M234.92,119.27h9.29c6.62,0,10.59,3.07,10.59,8.16,0,5.4-4,8.3-10.59,8.3h-9.29Zm5.62,12.78h2.67c4.27-.07,6-1.34,6-4.64,0-3-2.12-4.44-6-4.44h-2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.57,128.93c0,4.78-2.88,7.15-9.41,7.15s-9.41-2.37-9.41-7.15v-9.66h5.62v9.92c0,2.12,1,3.2,3.79,3.2s3.79-1.08,3.79-3.2v-9.92h5.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.2,119.27h5.71L300,135.73h-5.87l-1.33-2.95h-7.53l-1.36,2.95h-5.77Zm.37,10.34h4.91l-2.39-5.76H289Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "301.59 119.27 307.37 119.27 314.87 129.41 314.93 129.41 314.93 119.27 320.23 119.27 320.23 135.73 314.44 135.73 306.94 125.47 306.88 125.47 306.88 135.73 301.59 135.73 301.59 119.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330,119.27h5.71l8.09,16.46h-5.88l-1.33-2.95H329l-1.35,2.95H321.9Zm.36,10.34h4.91l-2.39-5.76h-.06Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetras);
export default __webpack_public_path__ + "static/media/letras.3532221af48d4bb37587c5697be1bcd0.svg";
export { ForwardRef as ReactComponent };